import React, { ButtonHTMLAttributes, useEffect, useMemo, useState } from 'react';
import { IconType } from 'react-icons/lib';
import { debounce } from "lodash-es"

export enum State {
    NotAvailable,
    Available,
};

interface CircularButtonWithToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon: IconType;
    text: string;
    desc?: string;
    onChangeState?: Function;
    delayedOnChangeState?: (s: State) => void;
    lastStatus?: boolean | null;
    'data-tip': string
}


const CircularButtonWithToggle: React.FC<CircularButtonWithToggleProps> = ({
    icon: IconComponent,
    text,
    desc,
    delayedOnChangeState,
    lastStatus = null,
    className,
    ...rest
}) => {
    const [activate, setActivate] = useState(lastStatus ?? false);
    const [newActivate, setNewActivate] = useState(lastStatus ?? false);

    const f = useMemo(() => debounce((state) => {
        // logger.debug('trigger state', activate, state)
        if (activate != state) {
            // logger.debug("send state", state)
            delayedOnChangeState?.(state ? State.Available : State.NotAvailable)
            setActivate(state)
        }
    }, 2500), [delayedOnChangeState])

    useEffect(() => {
        if (lastStatus != undefined) {
            setActivate(lastStatus)
            setNewActivate(lastStatus)
        }
    }, [lastStatus])

    const onClick = () => {
        f.cancel()
        setNewActivate(newActivate => {
            f(!newActivate)
            return !newActivate
        })
    }



    return (
        <div className='tooltip tooltip-right' {...(rest['data-tip'] && { 'data-tip': rest['data-tip'] })}>
            <button className={`btn btn-md btn-outline rounded-full pl-1 h-12 border-base-300 ${newActivate ? 'bg-primary' : ''} ${className ?? ''}`} {...rest} onClick={onClick}>
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-base-content ${newActivate ? 'bg-secondary text-primary' : 'bg-base-300'}`}>
                    <IconComponent className='w-6 h-6' />
                </div>
                <div className='flex flex-col'>
                    {text}
                    <span className='text-sm font-normal normal-case'>{desc}</span>
                </div>
            </button>
        </div>
    );
};

export default CircularButtonWithToggle;
